import React from "react"
import { TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn, FontIcon } from "material-ui"
import Table from "../../components/common/Table"
import strings from "../../localization/strings"
import { green500 } from "material-ui/styles/colors"
import { ISchedulePreference, IUserDocument } from "../../models"
import moment from "moment"
import ClientLocalDateTimeStr from "../../components/common/ClientLocalDateTimeStr"

interface IProps {
    readonly: boolean
    user: IUserDocument
    schedulePreferences: ISchedulePreference[]
    selectedSchedulePreferences: ISchedulePreference[]
    handleSelect(selectedSchedulePreferences: ISchedulePreference[]): void
    handleUpdate(editSchedulePreference: ISchedulePreference): void
}

const UserDetailWorkPreferenceTable: React.SFC<IProps> = (props: IProps) => {
    return (
        <Table
            readonly={props.readonly}
            allowClickRow
            items={props.schedulePreferences}
            handleClickRow={schedulePreference => !props.readonly && props.handleUpdate(schedulePreference)}
            handleSelect={selectedSchedulePreferences => !props.readonly && props.handleSelect(selectedSchedulePreferences)}
        >
            <TableHeader>
                <TableRow>
                    <TableHeaderColumn style={{ width: 125 }}>{strings.Start_Date}</TableHeaderColumn>
                    <TableHeaderColumn style={{ width: 125 }}>{strings.End_Date}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "center", width: 50 }}>{strings.Preferred}</TableHeaderColumn>
                    <TableHeaderColumn style={{ textAlign: "center", width: 70 }}>{strings.Unavailable}</TableHeaderColumn>
                    <TableHeaderColumn>{strings.Note}</TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody showRowHover={true} deselectOnClickaway={false}>
                {props.schedulePreferences.map((preference, i) =>
                    <TableRow
                        data-intercom-target={i === 0 && "menu-EmployeeWorkPref-openEmployeeWorkPrefDetails"}
                        key={preference.Id}
                        selected={props.selectedSchedulePreferences.find(item => item.Id === preference.Id) ? true : false}
                    >
                        <TableRowColumn style={{ width: 125 }}>
                            <ClientLocalDateTimeStr
                                hierarchyId={props.user.DefaultPunchHierarchyId}
                                jobId={props.user.DefaultJobId}
                                utcTime={moment(preference.StartTime).format()}
                                formatStr="MM/DD/YYYY h:mma"
                            />
                        </TableRowColumn>
                        <TableRowColumn style={{ width: 125 }}>
                            <ClientLocalDateTimeStr
                                hierarchyId={props.user.DefaultPunchHierarchyId}
                                jobId={props.user.DefaultJobId}
                                utcTime={moment(preference.EndTime).format()}
                                formatStr="MM/DD/YYYY h:mma"
                            />
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "center", width: 50 }}>
                            {preference.Preferred &&
                                <FontIcon
                                    className="fa fa-check"
                                    style={{ fontSize: 18, color: green500 }}
                                />
                            }
                        </TableRowColumn>
                        <TableRowColumn style={{ textAlign: "center", width: 70 }}>
                            {preference.UnAvailable &&
                                <FontIcon
                                    className="fa fa-check"
                                    style={{ fontSize: 18, color: green500 }}
                                />
                            }
                        </TableRowColumn>
                        <TableRowColumn>
                            <div className="TextOverflow" title={preference.Note}>{preference.Note}</div>
                        </TableRowColumn>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    )
}

export default UserDetailWorkPreferenceTable